import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const APP_NAME = "ERP";

const useDocumentTitle = (titleKey, entityName) => {
  const { t } = useTranslation("pageTitle");

  useEffect(() => {
    if (titleKey) {
      const pageTitle = t(titleKey);
      document.title = entityName
        ? `${entityName} - ${pageTitle} | ${APP_NAME}`
        : `${pageTitle} | ${APP_NAME}`;
    } else {
      document.title = APP_NAME;
    }
    return () => {
      document.title = APP_NAME;
    };
  }, [titleKey, entityName, t]);
};

export default useDocumentTitle;
